import { useState } from "react";
import { useTranslation } from "react-i18next";

const API = process.env.REACT_APP_API_BASE_URL || "";

export default function OrderLookup() {
  const { t } = useTranslation();
  const [orderNumber, setOrderNumber] = useState("");
  const [phone, setPhone] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [order, setOrder] = useState(null);

  async function handleLookup(e) {
    e.preventDefault();
    setError("");
    setOrder(null);
    setLoading(true);
    try {
      const res = await fetch(`${API}/orders/guest-lookup`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ order_number: orderNumber.trim(), phone: phone.trim() }),
      });
      if (res.status === 404) {
        setError(t("orderLookup.notFound"));
        return;
      }
      if (!res.ok) {
        setError(t("orderLookup.lookupFailed"));
        return;
      }
      const data = await res.json();
      setOrder(data.order);
    } catch {
      setError(t("orderLookup.lookupFailed"));
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="auth-wrapper">
      <div className="auth-card">
        <h2 className="auth-title">{t("orderLookup.title")}</h2>

        <form className="auth-form" onSubmit={handleLookup}>
          <label style={{ display: "flex", flexDirection: "column", gap: 6, fontSize: "0.85rem", fontWeight: 600, color: "#555" }}>
            {t("orderLookup.orderNumber")}
            <input
              className="auth-input"
              type="text"
              value={orderNumber}
              onChange={(e) => setOrderNumber(e.target.value)}
              required
              placeholder={t("orderLookup.orderNumberPlaceholder")}
              style={{ marginTop: 0 }}
            />
          </label>
          <label style={{ display: "flex", flexDirection: "column", gap: 6, fontSize: "0.85rem", fontWeight: 600, color: "#555" }}>
            {t("orderLookup.phone")}
            <input
              className="auth-input"
              type="tel"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              required
              placeholder={t("orderLookup.phonePlaceholder")}
              style={{ marginTop: 0 }}
            />
          </label>

          {error && <p className="auth-error-text">{error}</p>}

          <button
            type="submit"
            disabled={loading}
            className="auth-btn"
          >
            {loading ? t("orderLookup.searching") : t("orderLookup.lookupBtn")}
          </button>
        </form>

        {order && (
          <div style={{ marginTop: 24, paddingTop: 20, borderTop: "1px solid #eef3f8" }}>
            <h3 style={{ fontSize: "1rem", fontWeight: 600, color: "#3f6690", marginBottom: 12 }}>{t("orderLookup.resultTitle")}</h3>
            <div style={{ lineHeight: 1.8, fontSize: "0.92rem", color: "#444" }}>
              <div><b>{t("orderLookup.orderNumber")}:</b> {order.order_number}</div>
              <div><b>{t("orderLookup.status")}:</b> {order.status || "-"}</div>
              <div><b>{t("orderLookup.customerName")}:</b> {order.customer_name}</div>
              <div><b>{t("orderLookup.recipientName")}:</b> {order.recipient_name || order.customer_name}</div>
              <div><b>{t("orderLookup.address")}:</b> {[order.zipcode, order.address, order.address_detail].filter(Boolean).join(" ")}</div>
              <div><b>{t("orderLookup.createdAt")}:</b> {order.created_at ? new Date(order.created_at).toLocaleString() : "-"}</div>
              {order.memo && <div><b>{t("orderLookup.memo")}:</b> {order.memo}</div>}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
